import React from 'react';
import { useLocation } from 'react-router-dom';
import MarketingShell from '../marketing/MarketingShell';
import PageMeta from '../seo/PageMeta';

const COPY = {
  privacy: {
    title: 'Privacy Policy',
    body: `QnaRead collects account information (name, email) and learning activity (read status, saves, reviews) to provide the service. We do not sell personal data. AI requests are processed on our servers; do not submit secrets in questions. Contact support for data export or deletion requests. This draft requires legal review before production.`,
  },
  terms: {
    title: 'Terms of Service',
    body: `By using QnaRead you agree to use the service lawfully and not abuse AI or upload features. Content you add remains your responsibility. The service is provided as-is without warranty. Subscription terms will apply when billing launches. This draft requires legal review before production.`,
  },
  about: {
    title: 'About QnaRead',
    body: `QnaRead.com is a learning notebook built for developers, students, and professionals who want structured Q&A with AI-assisted understanding and revision.`,
  },
  cookies: {
    title: 'Cookie Policy',
    body: `We use essential cookies for authentication (HttpOnly session tokens). Optional analytics cookies may be added with consent. You can clear cookies by logging out or using browser settings. This draft requires legal review.`,
  },
  refund: {
    title: 'Refund Policy',
    body: `When paid subscriptions launch, refund terms will follow applicable consumer laws and payment provider rules. Until billing is enabled, no charges apply. This draft requires legal review.`,
  },
};

export default function LegalPage({ variant = 'privacy' }) {
  const { pathname } = useLocation();
  const { title, body } = COPY[variant] || COPY.privacy;
  return (
    <MarketingShell title={title}>
      <PageMeta title={title} canonicalPath={pathname} />
      <p className="marketing-lead" style={{ whiteSpace: 'pre-wrap' }}>{body}</p>
    </MarketingShell>
  );
}
